import { createReducer, on } from '@ngrx/store';
import { ConnectorsState } from './connector.models';
import * as connectorActions from './connector.actions';
import * as paginationConstants from '../../../shared/constants/pagination.constants';
import { ConnectorUtils } from '../utils/connector.util';

export const initialConnectorState: ConnectorsState = {
  connectors: [],
  connectorsPage: null,
  pagination: {
    pageIndex: 0,
    pageSize: paginationConstants.DefaultPageSize,
  },
  connectorFilter: null,
  connectorFilterParameters: null,
  loading: false,
  error: null,
  connectorNumbers: null,
  connectorConfiguration: null,
  connectorConfigurationSaving: false,
  connectorConfigurationSavedSuccessfully: false,
};

export const connectorReducer = createReducer(
  initialConnectorState,
  on(connectorActions.loadConnectorList, (state) => ({
    ...state,
    loading: true,
  })),
  on(connectorActions.loadConnectorListFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.errorMessage ?? 'Error',
  })),
  on(
    connectorActions.loadConnectorListSuccess,
    (state, { connectorResponse }) => ({
      ...state,
      loading: false,
      error: null,
      connectors: connectorResponse.result ?? [],
      connectorsPage: {
        ...state.connectorsPage,
        totalCount: connectorResponse.total ?? 0,
        pageIndex: connectorResponse.pageIndex ?? 0,
        pageSize: connectorResponse.pageSize ?? 0,
      },
    })
  ),
  on(connectorActions.changePagination, (state, { pageIndex, pageSize }) => ({
    ...state,
    pagination: {
      pageIndex,
      pageSize,
    },
  })),
  on(connectorActions.patchConnectorStatuses, (state, { statusData }) => ({
    ...state,
    connectors: ConnectorUtils.updateStatuses(state.connectors, statusData),
  })),
  on(connectorActions.updateConnectorFilter, (state, { filter }) => ({
    ...state,
    connectorFilter: filter,
  })),
  on(
    connectorActions.loadConnectorNumbersByStatusSuccess,
    (state, { value }) => ({
      ...state,
      connectorNumbers: value,
    })
  ),
  on(connectorActions.loadConnectorConfiguration, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    connectorActions.loadConnectorConfigurationSuccess,
    (state, { connectorConfiguration }) => ({
      ...state,
      loading: false,
      connectorConfiguration: connectorConfiguration,
    })
  ),
  on(
    connectorActions.loadConnectorConfigurationFailure,
    (state, { error }) => ({
      ...state,
      loading: false,
      error: error.errorMessage ?? 'Error',
    })
  ),
  on(connectorActions.updateChargePoint, (state) => ({
    ...state,
    connectorConfigurationSaving: true,
    connectorConfigurationSavedSuccessfully: false,
  })),
  on(connectorActions.updateChargePointFailure, (state, { error }) => ({
    ...state,
    connectorConfigurationSaving: false,
    error: error.errorMessage ?? 'Error',
    connectorConfigurationSavedSuccessfully: false,
  })),
  on(connectorActions.updateChargerPointSuccess, (state, { chargePoint }) => ({
    ...state,
    connectorConfigurationSaving: false,
    connectorConfigurationSavedSuccessfully: true,
    connectorConfiguration: {
      ...state.connectorConfiguration,
      plugType: chargePoint.plugType,
      powerType: chargePoint.powerType,
      meterNumber: chargePoint.meterNumber,
      cableType: chargePoint.cableType,
    },
  })),
  on(connectorActions.updateChargePointReset, (state) => ({
    ...state,
    connectorConfigurationSaving: false,
    connectorConfigurationSavedSuccessfully: false,
  })),
  on(connectorActions.updateConnectorMaxChargingCapacity, (state, { maxChargingCapacity }) => ({
    ...state,
    connectorConfiguration: state.connectorConfiguration
      ? { ...state.connectorConfiguration, maxChargingCapacity }
      : state.connectorConfiguration,
  })),
  on(connectorActions.loadConnectorSuccess, (state, payload) => ({
    ...state,
    currentConnector: payload.connector,
  })),
  on(connectorActions.loadConnectorsFilterParameters, (state) => ({
    ...state,
    loading: true,
    connectorFilterParameters: null,
  })),
  on(
    connectorActions.loadConnectorsFilterParametersSuccess,
    (state, { filterParameters }) => ({
      ...state,
      loading: false,
      connectorFilterParameters: {
        ...filterParameters,
      },
    })
  ),
  on(
    connectorActions.loadConnectorsFilterParametersFailure,
    (state, { error }) => ({
      ...state,
      loading: false,
      error: error.errorMessage ?? 'ERROR',
    })
  )
);
